import { NotaFiscalSaidaListarRequest } from '@shared/services/requests/repo-dfe/nota-fiscal-saida-listar.request';
import { NotaFiscalSaidaLookupStruct } from '@shared/services/structs/repo-dfe/nota-fiscal-saida-lookup.struct';

export class NotaFiscalSaidaImpressaoListaDialogData {
  /** Os mesmos filtros da listagem: o relatório leva ao papel o que está na tela. */
  filtro: NotaFiscalSaidaListarRequest;
  /** Texto do período aplicado, para o cabeçalho do relatório. */
  rotuloPeriodo: string;
  /** Nomes dos status, já recebidos pela listagem. */
  listaStatus: NotaFiscalSaidaLookupStruct[];
}
